const rawAuthDisabled = String(
  import.meta.env.VITE_AUTH_DISABLED ?? 'true'
).toLowerCase()

export const AUTH_DISABLED =
  rawAuthDisabled === 'true' ||
  rawAuthDisabled === '1' ||
  rawAuthDisabled === 'yes'

export const OPERATOR_ID = String(import.meta.env.VITE_OPERATOR_ID || '').trim()
